type Breakpoints = number[];

export const breakpoints: Breakpoints = [1920, 1440, 1200, 990];

export const mq = breakpoints.map((size) => `@media (max-width: ${size}px)`);
